export default function(videoId) {
  return `https://res.cloudinary.com/ilo/video/upload/v1/ilo100-staging/${videoId}.mp4`;
}

export const getVideoCaptionUrlById = (language, videoId) =>
  `https://admin-staging.ilo100.org/api/content/captions/${language}/tripartism/${videoId}`;
